import styled from 'styled-components';

/**
 * CleverParking columnar time picker (ported from caps-mnemo, re-themed for the
 * CRM with --cp-* tokens so it works in BOTH light and dark). Replaces the old
 * analog clock. Hex values in var() are v1 fallbacks (vars only exist in v2).
 */

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 18px 20px 8px;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 74px;
`;

export const ColLabel = styled.div`
  text-align: center;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cp-text-tertiary, #6b767d);
  margin-bottom: 8px;
`;

export const ScrollList = styled.div`
  position: relative;
  height: 182px;
  overflow-y: auto;
  background: var(--cp-bg, #f3f5f4);
  border: 1px solid var(--cp-border-soft, #dee3e7);
  border-radius: 10px;
  padding: 71px 4px;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--cp-scroll-thumb, #d1d5db);
    border-radius: 3px;
  }
`;

export const Opt = styled.div`
  padding: 7px 0;
  text-align: center;
  border-radius: 7px;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
  color: var(--cp-text-secondary, #4b565e);
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
  &:hover {
    background: var(--cp-surface-hover, #f5f7f6);
    color: var(--cp-text, #232a2d);
  }
  &.active {
    background: var(--cp-green, #47b972);
    color: #ffffff;
    font-weight: 600;
  }
`;
